export * from './keys';
export * from './urls';
export * from './validationRegex';

export const PAGE_SIZE_IMPORTED_EMPLOYEES = 100;
export const PAGE_SIZE_IMPORTED_EMPLOYEES_IN_DIALOG = 100;
export const PAGE_SIZE_EMPLOYEES = 50;
export const PAGE_SIZE_EMPLOYER_CREDITS_HISTORY = 10;
